module.exports = __webpack_public_path__ + "img/upload.7c730694.svg";